import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { BankStatementImportFileHdrContainerModel } from '../../../../../../models/aggregates/erp/index';
import { ApiVisa } from '../../shared';

@Injectable({
    providedIn: 'root'
})
export class BankStatementImportFileHdrService extends BaseApiTemplateService<BankStatementImportFileHdrContainerModel> {
    readonly url = Core2Config.DOMAIN_URL  + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'default-bank-statement/' + Core2Config.BACKOFFICE_EP_SUFFIX;

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'default-bank-statement/' + Core2Config.BACKOFFICE_EP_SUFFIX;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'default-bank-statement/' + Core2Config.BACKOFFICE_EP_SUFFIX;
        this.httpClient = http;
    }

    public uploadDefaultBankStmtImportFile(formData: FormData, visa: ApiVisa) {
        if (this.endpoint_path && visa.api_domain_url) {
            this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        const url = this.apiUrl;
        return this.httpClient.post(url, formData, this.getHttpHeader(visa));
    }

    async downloadDefaultBankStmtCSV(authorization: string, apiVisa: ApiVisa) {
        const CSV_URL = apiVisa.api_domain_url + this.endpoint_path + '/download-master-data-template';
        const headers = new HttpHeaders({ "authorization": authorization, "tenantCode": apiVisa.tenantCode });
        const fileBlob = await this.httpClient
            .get(CSV_URL, { headers, responseType: 'blob' })
            .toPromise();
        return fileBlob;
    }
}
